module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "nav-view"
  }, [_c('h3', {
    staticClass: "nav-view-content"
  }, [_vm._v("\n    " + _vm._s(_vm.content) + "\n  ")]), _vm._v(" "), _c('BottomNav', {
    staticClass: "tab-nav",
    attrs: {
      "value": "0"
    }
  }, [_c('NavItem', {
    attrs: {
      "value": "0",
      "title": "tab 1",
      "img": "https://imgly.net/img/2gj.jpg"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onTab('AAA')
      }
    }
  }), _vm._v(" "), _c('NavItem', {
    attrs: {
      "value": "1",
      "title": "tab 2",
      "icon": "fa fa-bank",
      "info-num": "10"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onTab('BBB')
      }
    }
  }), _vm._v(" "), _c('NavItem', {
    attrs: {
      "value": "2",
      "title": "tab 3",
      "icon": "fa fa-birthday-cake",
      "info-num": "100"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onTab('CCC')
      }
    }
  }), _vm._v(" "), _c('NavItem', {
    attrs: {
      "value": "3",
      "title": "tab 4",
      "icon": "fa fa-binoculars",
      "info-num": "dot"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onTab('DDD')
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-5d206b3c!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/navView.vue
// module id = 248
// module chunks = 0